import React from "react";
import {useSelector} from 'react-redux';
import {getTimezoneDate} from 'containers/MundialViews/utils/mundialUtils';
import { getRegion } from 'utils/Region';
import './MatchCard.scss';
import {showPlaceHolderorImg} from 'containers/MundialViews/utils/mundialUtils'
import StatusGame from './componets/StatusGame/StatusGame';
import DetailsOfMatch from './componets/DetailsOfMatch/DetailsOfMatch';
import {pushEvent} from 'containers/Player/utils/analytics';
import {events,Actions, category} from 'containers/MundialViews/utils/analytics';
import { useNavigate } from "react-router-dom";

const MatchCard = ({homeImg,homeTitle,awayImg,awayTitle,time,id,status,state})=>{
  const navigate = useNavigate();
    const {match_detail_info_games_img_live_next:imgBg,
      ribbon_match_placeholder_img:placeholderCardCarousel} = useSelector(state => state.asset)
    
    const {
      match_detail_info_games_label_1H:firstTime,
      match_detail_info_games_label_HT:halfTime,  
      match_detail_info_games_label_2H:secondTime,
      match_detail_info_games_label_COMPLETED:endTime,
      match_detail_info_games_label_I90:restTime,
        match_detail_info_games_label_1ET:firstExtraTime,
        match_detail_info_games_label_I105:restExtraTime,
        match_detail_info_games_label_2ET:secondExtraTime,
        match_detail_info_games_label_PSO:penales,
        matches_result_separatorVersus_label:vs,
        match_detail_hourAbbreviation_label:hs

        

    } = useSelector(state=>state.translations
        )
    const dateMatch = getTimezoneDate(time);
    const handlePlayerClick = id => {
        pushEvent(
          events.CARRUSELES,
          category.CARRUSELES,
          Actions.CARDMATCH,
          `${homeTitle?.toLowerCase()} ${vs} ${awayTitle?.toLowerCase()}`
        )
        window.scrollTo(0,0)
        return navigate(`/${getRegion()}/vcard/match/${id}`);
      };

      const returnImg = showPlaceHolderorImg(imgBg,placeholderCardCarousel);
    return (
        <div className="matchCard" onClick={()=>handlePlayerClick(id)} style={{backgroundImage:`url(${returnImg?.classHolder ? returnImg.placeholder : returnImg})`}}>
          <DetailsOfMatch status={status} homeImg={homeImg} homeTitle={homeTitle} awayImg={awayImg} awayTitle={awayTitle} vs={vs} />
           <StatusGame status={status} state={state} dateMatch={dateMatch} firstTime={firstTime} 
           secondTime={secondTime} firstExtraTime={firstExtraTime} secondExtraTime={secondExtraTime} 
           penales={penales} halfTime={halfTime} restExtraTime={restExtraTime} restTime={restTime}
           hs={hs}
           />
        </div>
           

    )
}

export default MatchCard;